export const caseDetailsConstants = {
  CASE_DETAILS_REQUEST: 'CASE_DETAILS_REQUEST',
  CASE_DETAILS_SUCCESS: 'CASE_DETAILS_SUCCESS',
  CASE_DETAILS_FAILURE: 'CASE_DETAILS_FAILURE',
};
